import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { blockConfig } from '../../../config';

const BlockBorderWrapper = styled.div`
  height: 5px;
  display: block;
  bottom: 0;
  width: ${p => p.width};
  position: absolute;
  left ${p => p.left};
  ${(p) => {
    if (p.showAs === blockConfig.showAs.tentative) {
      return css`
        background: repeating-linear-gradient(
          120deg,
          #fff,
          #fff 5px,
          ${p.color} 5px,
          ${p.color} 10px
        );
      `;
    }
    return css`
      background: ${p.color};
    `;
  }}

  ${p =>
    p.arrows &&
    (p.arrows === blockConfig.arrows.left || p.arrows === blockConfig.arrows.both) &&
    css`
      border-bottom-left-radius: 0px;
    `}

  ${p =>
    p.arrows &&
    (p.arrows === blockConfig.arrows.right || p.arrows === blockConfig.arrows.both) &&
    css`
      border-bottom-right-radius: 0px;
    `}
`;

const BlockBorder = ({ showAs, color, arrows, width = 100, left }) =>
  <BlockBorderWrapper arrows={arrows} showAs={showAs} color={color} width={width} left={left} />;

BlockBorder.propTypes = {
  showAs: PropTypes.string,
  color: PropTypes.string,
  arrows: PropTypes.string,
  width: PropTypes.number,
  left: PropTypes.number,
};

export default React.memo(BlockBorder);
